import React, { useEffect, useRef, useState } from 'react';

const stats = [
  { value: 2654, suffix: '+', label: 'Total Students' },
  { value: 15, suffix: '+', label: 'Years Experience' },
  { value: 328, suffix: '+', label: 'Experienced Teachers' },
  { value: 100, suffix: '%', label: 'Background Verified' },
];

const useCountUp = (target, duration = 2000, start = false) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, start]);
  return count;
};

const StatItem = ({ stat, animate }) => {
  const count = useCountUp(stat.value, 2000, animate);
  return (
    <div className="flex flex-col items-center justify-center text-center px-4">
      <span className="text-4xl md:text-5xl font-extrabold text-primary tracking-tight mb-1 drop-shadow-sm tabular-nums">
        {count.toLocaleString()}{stat.suffix}
      </span>
      <span className="text-xs md:text-sm font-bold text-slate-600 uppercase tracking-widest mt-1">
        {stat.label}
      </span>
    </div>
  );
};

const StatsBar = () => {
  const [animate, setAnimate] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setAnimate(true); observer.disconnect(); } },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className="bg-white py-10 relative z-20 border-b border-gray-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 divide-x-0 lg:divide-x divide-gray-100">
          {stats.map((s, i) => (
            <StatItem key={i} stat={s} animate={animate} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsBar;